import React from 'react';
import { GroupRoleType, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n';
import { useToolbarContext } from '../../hooks/use-toolbar-context';

const TitleController = () => {
    const { $t } = useLocaleStore();
    const { pickLayerType, layerType, role } = useToolbarContext();

    //二维码layerType=qr_code,需要转化为‘qrCode’
    //水印layerType=watermark,需要转化为‘waterMark’
    const name = (type: LayerType, role: GroupRoleType | null) => {
        switch (type) {
            case LayerType.QR_CODE:
                return 'qrCode';
            case LayerType.WATERMARK:
                return 'waterMark';
            case LayerType.MARKUP_LAYER:
                return 'brush';
            case LayerType.GROUP_LAYER:
                if (!role) return type;
                else return role;
            default:
                return type;
        }
    };

    /**
     * 获取标题
     * 1. 如果pickLayerType存在，展示组合-{pickLayerType}
     * 2. 如果pickLayerType不存在，展示{layerType}
     */

    const getTitle = () => {
        if (pickLayerType) {
            return `${$t((v) => v.headerToolbar.title[name(layerType, role)])} - ${$t((v) => v.headerToolbar.title[name(pickLayerType, role)])}`;
        } else {
            return $t((v) => v.headerToolbar.title[name(layerType, role)]);
        }
    };
    return <div className="c-header-toolbar-title">{getTitle()}</div>;
};

export default React.memo(TitleController);
